export default function RedDeleteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2499 9.75V15.75M9.74988 9.75V15.75M20.2495 5.25L3.74951 5.25001M18.7499 5.25V19.5C18.7499 19.6989 18.6709 19.8897 18.5302 20.0303C18.3896 20.171 18.1988 20.25 17.9999 20.25H5.99988C5.80097 20.25 5.6102 20.171 5.46955 20.0303C5.3289 19.8897 5.24988 19.6989 5.24988 19.5V5.25M15.7499 5.25V3.75C15.7499 3.35218 15.5918 2.97064 15.3105 2.68934C15.0292 2.40804 14.6477 2.25 14.2499 2.25H9.74988C9.35205 2.25 8.97052 2.40804 8.68922 2.68934C8.40791 2.97064 8.24988 3.35218 8.24988 3.75V5.25"
        stroke="#FF3838"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
